<template>
  <div class="contact-via">
    <template v-if="onlyIcon">
      <el-popover
        placement="top-start"
        trigger="hover"
        title="Contact us via Telegram"
      >
        <template #reference>
          <a class="telegram-button" @click="telegramSubscription">
            <font-awesome-icon :icon="['fab', 'telegram']" />
          </a>
        </template>
      </el-popover>
      <el-popover
        placement="top-start"
        trigger="hover"
        title="Contact us via Email"
      >
        <template #reference>
          <a class="email-button" href="mailto:support@traforama.com">
            <font-awesome-icon :icon="['fas', 'envelope']" />
          </a>
        </template>
      </el-popover>
      <el-popover
        v-if="showWidget"
        placement="top-start"
        trigger="hover"
        title="Contact us via Chat"
      >
        <template #reference>
          <a class="chat-button" @click="chatSubscription">
            <font-awesome-icon :icon="['fas', 'headset']" />
          </a>
        </template>
      </el-popover>
    </template>
    <template v-else>
      <div class="mb-1">
        <b>Contact us via:</b>
      </div>
      <a class="telegram-button" @click="telegramSubscription">
        <font-awesome-icon :icon="['fab', 'telegram']" size="3x" />
      </a>
      <a class="email-button" href="mailto:support@traforama.com">
        <font-awesome-icon :icon="['fas', 'envelope']" size="3x" />
      </a>
      <a v-if="showWidget" class="chat-button" @click="chatSubscription">
        <font-awesome-icon :icon="['fas', 'headset']" size="3x" />
      </a>
    </template>
  </div>
</template>
<script lang="ts">
declare global {
  interface Window {
    widget: any
  }
}

import { defineComponent, computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/modules/user'

export default defineComponent({
  name: 'MessengerSubscription',
  props: {
    mini: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const userStore = useUserStore()
    const { widgetEnabled, isWidgetScriptLoaded } = storeToRefs(userStore)

    const telegramSubscription = async () => {
      const link = await userStore.GetTelegramLink()
      window.open(link, '_blank')
    }

    const chatSubscription = () => {
      window.widget?.sendCommand('wakeup')
    }

    const telegramConnected = computed(() => {
      return userStore.connectedMessengers.includes('telegram')
    })

    const onlyIcon = computed(() => {
      return props.mini
    })

    const showWidget = computed(() => {
      return widgetEnabled.value && isWidgetScriptLoaded.value
    })

    return {
      telegramSubscription,
      telegramConnected,
      onlyIcon,
      chatSubscription,
      showWidget
    }
  }
})
</script>
<style lang="scss" scoped>
.contact-via {
  color: var(--menu-text-color);
  font-size: 14px;
  text-align: center;
  b {
    padding-bottom: 10px;
  }
}
.telegram-button,
.email-button,
.chat-button {
  width: auto;
  color: #ffffff;
  margin: 0 5px;
  padding: 5px;
  border-radius: 5px;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  &:hover {
    color: #54a9eb;
  }
}
</style>
